import { Rule } from '../models/Product';
import { AdditionalInformations } from '../modules/validateRules';
import { getGenericModalRule } from './catalogRules';

export const verifyGenericModalCondition = ({
  genericModals,
  when,
  condition
}: {
  genericModals: AdditionalInformations[];
  condition: string;
  when: string;
}) => {
  return genericModals.find(modal => {
    if (Array.isArray(modal.trigger.when)) {
      if (modal.trigger.when.some(item => item === when) && modal.trigger.condition === condition) return modal;
    } else if (modal.trigger.when === when && modal.trigger.condition === condition) return modal;
  });
};

export function handleGenericModals(rules: Rule[]) {
  const genericModals = getGenericModalRule(rules);
  if (genericModals?.value) return JSON.parse(genericModals.value) as AdditionalInformations[];
}

export function findGenericModal(props: { when: string; condition: string; genericModals: AdditionalInformations[] }) {
  return props.genericModals.find(modal => {
    if (Array.isArray(modal.trigger.when)) {
      if (modal.trigger.when.some(item => item === props.when) && modal.trigger.condition === props.condition)
        return modal;
    } else if (modal.trigger.when === props.when && modal.trigger.condition === props.condition) return modal;
  });
}

export function findGenericModalByCondition(props: { condition: string; genericModals: AdditionalInformations[] }) {
  return props.genericModals.find(modal => {
    if (modal.trigger.condition === props.condition) return modal;
  });
}
